import { useFormContext } from 'react-hook-form-mui';
import TestMultiplySelect from 'view/pages/profile/TestPage/MultiplySelect';
import JobLocationAutocomplete from 'view/pages/profile/components/JobLocationAutocomplete';
import * as WPS from 'view/pages/profile/WorkPreferences/styled';
import * as PSCS from 'view/pages/profile/ProfileSettings/styled';
import { Button, RadioGroup } from 'view/components';
import SalaryRange from 'view/components/SalaryRange';
import * as S from './styled';

export const yearsOfExperienceOptions = [
  {
    value: 'Less than 1 year',
    label: 'Less than 1 year',
    yearsOfExperienceMin: 0,
    yearsOfExperienceMax: 1,
  },
  {
    value: '1-2 years',
    label: '1-2 years',
    yearsOfExperienceMin: 1,
    yearsOfExperienceMax: 2,
  },
  { value: '3-5 years', label: '3-5 years', yearsOfExperienceMin: 3, yearsOfExperienceMax: 5 },
  { value: '6-10 years', label: '6-10 years', yearsOfExperienceMin: 6, yearsOfExperienceMax: 10 },
  {
    value: 'More than 10 years',
    label: 'More than 10 years',
    yearsOfExperienceMin: 10,
    yearsOfExperienceMax: 100,
  },
];

const FiltersBlockFields = ({
  positionTypeData,
  isPositionTypeDataLoading,
  educationData,
  isEducationDataLoading,
  setPage,
}) => {
  const { watch, setValue, control } = useFormContext<any>();

  const jobLocationValue = watch('jobLocation') ?? null;
  const salaryRange = watch('salaryRange') || { from: '', to: '' };

  return (
    <>
      <TestMultiplySelect
        name="positionType"
        label="Position Type *"
        options={positionTypeData || []}
        control={control}
        disabled={isPositionTypeDataLoading || !positionTypeData}
      />
      <JobLocationAutocomplete
        setValue={setValue}
        jobLocationValue={jobLocationValue}
        marginbottom={16}
      />
      <div>
        <WPS.TextTitle style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600' }}>
          Location Type
        </WPS.TextTitle>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginBottom: '16px' }}>
          <PSCS.CheckboxWithText>
            <PSCS.CustomCheckbox
              name="showPhone"
              checked={watch('onSite')}
              onChange={(e) => {
                return setValue('onSite', e.target.checked);
              }}
              disabled={false}
            />
            <p
              style={{
                color: '#444444',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '21.76px',
              }}
            >
              On-site
            </p>
          </PSCS.CheckboxWithText>
          <PSCS.CheckboxWithText>
            <PSCS.CustomCheckbox
              name="remote"
              checked={watch('remote')}
              onChange={(e) => {
                return setValue('remote', e.target.checked);
              }}
              disabled={false}
            />
            <p
              style={{
                color: '#444444',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '21.76px',
              }}
            >
              Remote
            </p>
          </PSCS.CheckboxWithText>
          <PSCS.CheckboxWithText>
            <PSCS.CustomCheckbox
              name="hybrid"
              checked={watch('hybrid')}
              onChange={(e) => {
                return setValue('hybrid', e.target.checked);
              }}
              disabled={false}
            />
            <p
              style={{
                color: '#444444',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '21.76px',
              }}
            >
              Hybrid
            </p>
          </PSCS.CheckboxWithText>
        </div>
      </div>
      <RadioGroup
        name="yearsOfExperience"
        label="Years of Experience"
        options={yearsOfExperienceOptions}
        style={{ marginBottom: '8px' }}
        styleLabel={{ margin: '0' }}
      />
      <TestMultiplySelect
        name="education"
        label="Education Level"
        options={educationData || []}
        control={control}
        disabled={isEducationDataLoading || !educationData}
      />
      <SalaryRange
        fromValue={salaryRange.from}
        toValue={salaryRange.to}
        onChange={(field, value) => {
          setValue('salaryRange', { ...salaryRange, [field]: value });
        }}
      />
      <Button
        variant="contained"
        type="submit"
        onClick={() => {
          return setPage(1);
        }}
        text="Apply filters"
        style={{ margin: '24px 0' }}
      />
    </>
  );
};

const JobPostsListFiltersBlock = ({
  onSubmit,
  setPage,
  positionTypeData,
  isPositionTypeDataLoading,
  educationData,
  isEducationDataLoading,
}) => {
  /* const { data: positionTypeData, isLoading: isPositionTypeDataLoading } = useGetDropdownData(
    DropdownsEnum.POSITION_TYPE
  ); */

  /* const { data: educationData, isLoading: isEducationDataLoading } = useGetDropdownData(
    DropdownsEnum.EDUCATION
  );
*/
  const { watch, setValue, handleSubmit } = useFormContext<any>();
  const formValues = watch(); // Следит за изменениями всех полей

  // Функция для подсчёта выбранных фильтров
  const countSelectedFilters = () => {
    let count = 0;

    if (formValues.positionType?.length) count++; // Тип занятости (массив)
    if (formValues.jobLocation) count++; // Локация
    if (formValues.onSite || formValues.remote || formValues.hybrid) count++; // Режим работы
    if (formValues.yearsOfExperience?.trim()) count++; // Опыт работы
    if (formValues.education?.length) count++; // Образование (массив)
    if (formValues.salaryRange?.from > 0 || formValues.salaryRange?.to > 0) count++; // Зарплата

    return count;
  };

  return (
    <S.FilterBlock
    /* style={{ opacity: isLoading ? 0.7 : 1, pointerEvents: isLoading ? 'none' : 'initial' }} */
    >
      <S.FilterBlockHeader>
        <S.FilterBlockHeaderFilters>
          <S.FilterBlockTitle>
            Filters <span>({countSelectedFilters()})</span>
          </S.FilterBlockTitle>
          <S.FilterBlockClear
            onClick={() => {
              setValue('positionType', null);
              setValue('jobLocation', null);
              setValue('onSite', false);
              setValue('remote', false);
              setValue('hybrid', false);
              setValue('yearsOfExperience', '');
              setValue('education', null);
              setValue('salaryRange', { from: '', to: '' });
              setPage(1);
              setTimeout(() => {
                return handleSubmit(onSubmit(1))();
              }, 0);
            }}
          >
            Clear
          </S.FilterBlockClear>
        </S.FilterBlockHeaderFilters>
        <S.FilterBlockDesc>
          {'Use filters to optimise your search \n and find a more suitable candidate'}
        </S.FilterBlockDesc>
      </S.FilterBlockHeader>
      <FiltersBlockFields
        positionTypeData={positionTypeData}
        isPositionTypeDataLoading={isPositionTypeDataLoading}
        educationData={educationData}
        isEducationDataLoading={isEducationDataLoading}
        setPage={setPage}
      />
    </S.FilterBlock>
  );
};

export default JobPostsListFiltersBlock;
